import { render, staticRenderFns } from "./LabIdentifyingSolutionsBasedOnReactions.vue?vue&type=template&id=1b023f4c&"
import script from "./LabIdentifyingSolutionsBasedOnReactions.vue?vue&type=script&lang=ts&"
export * from "./LabIdentifyingSolutionsBasedOnReactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports